import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";
import { instance } from "Actions/AxiosInstance";
import { CheckActionPermission } from "Actions/commonAction";
import department from "Assets/Icons/Department/department-16px.svg";
import designation from "Assets/Icons/Designation/designation-16px.svg";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DrawerHeader from "Component/Headers/drawerHeader";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import CustomLoader from "Component/CustomLoader";

import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { getFormattedImageLink } from "Utils";
import Create from "./create";

let shouldCallAPI = true;
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      listdata: [],
      backupList: [],
      offset: 0,
      limit: 20,
      fullcount: 1,
      value: 0,
      data: false,
      postData: null,
      selectedRow: null,
      open: false,
      headers: [
        {
          key: "categoryname",
          name: "Category name",
          style: { textAlign: "left" },
          type: TDTypeConsts.COMPETANCY_DESCRIPTION,
        },
        {
          key: "description",
          name: "Description",
          style: { textAlign: "left" },
          type: TDTypeConsts.COMPETANCY_DESCRIPTION,
        },
        {
          key: "defaultpriority",
          name: "Default Priority",
          style: { textAlign: "left" },
          type: TDTypeConsts.COMMONNAME,
        },
        {
          key: "ownertype",
          name: "Ticket owner",
          style: { textAlign: "left" },
          type: TDTypeConsts.ASSIGNED_OWNERS,
        },
        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
        },
        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.getAllTicketCategory = this.getAllTicketCategory.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.searchCategory = this.searchCategory.bind(this);
    this.toggleAssginedOwnerDrawer = this.toggleAssginedOwnerDrawer.bind(this);
    this.handleScroll1 = this.handleScroll1.bind(this);
  }

  searchCategory(e) {
    const { backupList, listdata } = this.state;
    const filterList = listdata.filter(
      (item) =>
        item.categoryname.toLowerCase().search(e.target.value.toLowerCase()) !==
        -1,
    );
    this.setState({
      searchValue: e.target.value,
      listdata: e.target.value ? filterList : backupList,
      isdata: filterList.length == 0 ? true : false,
      selectedRow: null,
    });
  }

  toggleAssginedOwnerDrawer(e, row) {
    instance
      .get(
        `helpdesk/getticketcategoryowner/${row.ticketcategoryid}/${row.ownertypeid}`,
      )
      .then((resp) => {
        this.setState({
          arrAssignedOwner: resp.data.result,
          drawerOpen: true,
        });
      });
  }

  onStateStatusChange = (value, selectedRow) => {
    const data = {
      ticketcategoryid: selectedRow.ticketcategoryid
        ? selectedRow.ticketcategoryid
        : null,
      status: value == 1 ? true : false,
    };

    this.props.enqueueSnackbar("Are you sure you want to change status?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance.post("helpdesk/changecategorystatus", data).then((res) => {
              this.setState(
                { isActive: res.data.result, offset: 0, fullcount: 1 },
                () => {
                  this.props.closeSnackbar();
                  this.getAllTicketCategory(true);
                },
              );
            });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  };

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll1);
  }

  handleScroll1() {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (this.state.fullcount > this.state.offset) {
        this.getAllTicketCategory(false);

        setTimeout(() => {
          shouldCallAPI = true;
        }, 2000);
      }
    }
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("ticketCategory");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getAllTicketCategory(false);
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.MORE_OPTIONS,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });

      if (this.props.history.location.pathname.includes("create")) {
        this.props.history.push(`${this.props.match.path}`);
      }
    } else {
      this.setState({ permissiondenied: true });
    }
    // this.getAllTicketCategory(false);
    window.addEventListener("scroll", this.handleScroll1);
  }

  getAllTicketCategory(isRefresh = false) {
    const { listdata } = this.state;
    if (isRefresh) {
      this.setState({
        fullcount:
          this.state.listdata.length == 0
            ? 1
            : this.state.listdata[0].fullcount,
        offset: this.state.listdata.length == 0 ? 0 : this.state.offset,
      });
    }
    const { limit, offset } = this.state;
    if (shouldCallAPI) {
      if (this.state.offset < this.state.fullcount) {
        shouldCallAPI = false;
        this.setState({isLoading: true}, () => {

       
        instance
          .get(`helpdesk/getallticketcategory/${limit}/${offset}`)
          .then((resp) => {
            let list = [];
            shouldCallAPI = true;
            isRefresh
              ? (list = [...resp.data.result])
              : (list = [...listdata, ...resp.data.result]);
            this.setState({
              listdata: list,
              backupList: resp.data.result,
              fullcount: resp.data.result[0]
                ? parseInt(resp.data.result[0].fullcount)
                : 1,
              offset: this.state.offset + this.state.limit,
              data: true,
              isLoading:false
            });
          });
        })
      }
    }
  }

  onCreate() {
    this.setState(
      {
        fullcount:
          this.state.listdata && this.state.listdata.length == 0 ? 1 : "",
        offset: 0,
      },
      () => {
        this.props.history.push(`${this.props.match.url}/create`);
      },
    );
  }

  onEdit() {
    const { selectedRow } = this.state;
    instance
      .get(`/helpdesk/getticketcategorybyid/${selectedRow.ticketcategoryid}`)
      .then((resp) => {
        const objTicketCategory = resp.data.result[0];
        const postData = {
          ticketcategoryid: selectedRow.ticketcategoryid,
          categoryname: objTicketCategory.categoryname,
          description: objTicketCategory.description,
          isattachmentrequired: objTicketCategory.isattachmentrequired,
          defaultpriorityid: objTicketCategory.defaultpriorityid,
          isdefaultassignment: objTicketCategory.isdefaultassignment,
          issenderanonymous: objTicketCategory.issenderanonymous,
          ownertypeid: objTicketCategory.ownertypeid,
          categoryowner: objTicketCategory.categoryowner,
          categoryapplicable: objTicketCategory.categoryapplicable,
        };

        this.setState({ postData, offset: 0, fullcount: "" }, () => {
          this.props.history.push(`${this.props.match.url}/create`);
        });

        this.setState({
          postData: null,
          createmenu: false,
          create_anchorEl: null,
          offset: 0,
          fullcount: "",
        });
      });
  }

  onDelete() {
    const { selectedRow } = this.state;
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .get(`recruit/deletehiringplan/${selectedRow.hiringplanid}`)
              .then(
                () => {
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });
                  this.props.closeSnackbar();
                  this.setState(
                    {
                      backupList: [],
                      fullcount: 1,
                      // data: [],
                      offset: 0,
                      createmenu: false,
                    },
                    () => {
                      this.getAllTicketCategory(true);
                    },
                  );
                },
                (error) => {
                  const CommonError = error.response
                    ? error.response.data.error.message
                    : error.message;
                  this.props.enqueueSnackbar(CommonError, { variant: "error" });
                  this.props.closeSnackbar();
                },
              );
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  renderCreate() {
    return (
      <Create
        {...this.props}
        postData={this.state.postData || null}
        onCreate={true}
        getAllTicketCategory={this.getAllTicketCategory}
      />
    );
  }

  renderList() {
    return (
      <div className="content-outer-wrapper">
        <p className="large-text-dark-secondary t-bold margin-bottom-16">
          Ticket Category
        </p>
        {this.state.isLoading ? 
        <CustomLoader/>
     :   <div>
        {this.state.listdata && this.state.listdata.length > 0 ? (
          <div>
           

            <List
              list={this.state.listdata}
              permissions={this.state.permissions}
              headers={this.state.headers}
              onCreate={this.onCreate}
              onEdit={this.onEdit}
              onDelete={this.onDelete}
              onStateStatusChange={this.onStateStatusChange}
              module="ticket category"
              onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
              toggleAssginedOwnerDrawer={(e, row) =>
                this.toggleAssginedOwnerDrawer(e, row)
              }
            />
            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => this.setState({ createmenu: false })}
              className="margin-top-8"
            >
              <Paper style={{ width: 190 }}>
                <div>
                  <MenuListComponent>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onEdit}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Edit</span>
                      </ListItemText>
                    </ListItem>
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
            <Drawer
              anchor="right"
              open={this.state.drawerOpen}
              onClose={() =>
                this.setState({
                  drawerOpen: false,
                  arrAssignedOwner: [],
                })
              }
              classes={{ paper: "width30" }}
            >
              <DrawerHeader
                header="Category Owner"
                isbackarrow={false}
                closeDrawer={() =>
                  this.setState({
                    drawerOpen: false,
                    arrAssignedOwner: [],
                  })
                }
              />
              {this.state.arrAssignedOwner &&
              this.state.arrAssignedOwner.length > 0 ? (
                this.state.arrAssignedOwner.map((owner) => (
                  <div className="display-flex employee-list-drawer">
                    <div>
                      <ProfilePicture
                        src={getFormattedImageLink(owner.imagepath)}
                        height="32"
                      />
                    </div>

                    <div className="margin-left-16" style={{ width: "86%" }}>
                      <Tooltip title={owner.fullname} placement="top">
                        <p className="normal-dark-secondary ellipsis width100">
                          {owner.fullname}
                        </p>
                      </Tooltip>
                      <Tooltip title={owner.designationname} placement="top">
                        <div className="margin-top-8 display-flex width100">
                          <img
                            src={designation}
                            className="margin-right-16"
                          ></img>
                          <p className="small-dark-secondary width100 ellipsis">
                            {owner.designationname || "-"}
                          </p>
                        </div>
                      </Tooltip>
                      <Tooltip
                        title={owner.departmentname || "-"}
                        placement="top"
                      >
                        <div className="margin-top-8 display-flex width100">
                          <img
                            src={department}
                            className="margin-right-16"
                          ></img>
                          <p className="small-dark-secondary width100 ellipsis">
                            {owner.departmentname || "-"}
                          </p>
                        </div>
                      </Tooltip>
                    </div>
                  </div>
                ))
              ) : (
                <p className="normal-dark-secondary text-center">
                  No data available
                </p>
              )}
            </Drawer>
          </div>
        ) : (
          <div className="position-rel">
            <DefaultComp
              heading="There are no ticket categories to display"
              subheading="Get started by creating your first ticket category!"
              imageSrc={empty}
            />
            {this.state.permissions.editable && (
              <div className="text-center margin-top-24">
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={this.onCreate}
                >
                  Create new
                </Button>
              </div>
            )}
          </div>
        )}
        </div>
        }
      </div>
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <IntlProvider locale="en">
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              {/* {this.state.data && ( */}
                <div>
                  <div>
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}`}
                        render={this.renderList}
                      />
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this.renderCreate}
                      />
                      <Redirect from={`${match.path}`} to={`${match.path}`} />
                    </Switch>
                  </div>
                </div>
              {/* )} */}
            </div>
          )}
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);
